module.exports = __webpack_public_path__ + "img/b4-3.32a0cc5.png";